module.exports = __webpack_public_path__ + "img/qrcode.88a8e067.jpg";